import React from 'react';
import loadable from '@loadable/component';
import { profileOnEnterSaga } from 'containers/Profile/profile.onenter.saga';

const Root = loadable(() => import('containers/Profile/Root'));
const Favorites = loadable(() => import('containers/Profile/Favorites'));
const Past = loadable(() => import('containers/Profile/Past'));
const UpcomingContainer = loadable(() => import('containers/Profile/UpcomingContainer'));

export default (store, client) => ({
  path: '/profile',

  onEnter: (nextState, replaceState, cb) =>
    store
      .runSagaOnce(profileOnEnterSaga, client, nextState, replaceState)
      .toPromise()
      .then(cb),

  component: props => <Root {...props} />,

  childRoutes: [
    { path: 'favorites', component: props => <Favorites {...props} /> },
    { path: 'past', component: props => <Past {...props} /> },
    { path: 'upcoming', component: props => <UpcomingContainer {...props} /> },
  ],
});
